module.exports = __webpack_public_path__ + "img/set-password.14607d2d.svg";